export const LANGUAGES = [
  { value: "ru", label: "Русский", shortened: "Рус" },
  { value: "en", label: "English", shortened: "Eng" },
  { value: "kk", label: "Қазақша", shortened: "Қаз" },
];
